import { Injectable } from '@angular/core';
import { CategoryDto } from '../models/object-category-dto';
import { ObjectDto } from '../models/object-dto';
import { ObjectRowsDto } from '../models/object-rows-dto';
import { WordDto } from '../models/word-dto';
import { CategoryId } from '../enums/category.enum';
import { MultiLangStrDto } from '../models/multi-lang-str-dto';
import { LanguageService } from './language.service';

const {OBJECT_TYPE, OBJECT_PART, TIPUS, SHALIT, TAT_SHALIT, 
    MITBAAH, ARICH, TVIAT_RECHEV, MANUSCRIPT_TYPE, CHIBUR_TYPE, 
    SUGA, CHIBUR, TAT_CHIBUR, KITZUR, COPY, LANGUAGE, WRITING, PERIOD_ISRAEL, 
    MATERIAL, TECHNIQUE, PERIOD_OVERSEAS, KEYWORDS, EXPEDITION} = CategoryId;
    @Injectable({
        providedIn: 'root'
    })
    export class ObjectService {
      currentLanguage$: any;
      constructor(private languageService: LanguageService) {}

    getRows(objectDetails: ObjectDto) {    
      this.currentLanguage$ = this.languageService.currentLanguage$;
      const siteValue = new MultiLangStrDto(
        `${objectDetails.objectAtarName?.hebrew || ''} ${objectDetails.objectAtar || ''}`.trim(),
        `${objectDetails.objectAtarName?.english || ''} ${objectDetails.objectAtar || ''}`.trim()
    );
        let categories: CategoryDto = {};
        objectDetails.objectWordsList.forEach((word: WordDto) => {
            if(!categories[word.categoryId]){
              categories[word.categoryId] = word;
            }else{
              categories[word.categoryId].wordName.hebrew += `, ${word?.wordName.hebrew}`;
              categories[word.categoryId].wordName.english += `, ${word?.wordName.english}`;
            }
          });
          let r=(objectDetails.objectAtarName || '') + ' '+(objectDetails.objectAtar || '')
        const rows: ObjectRowsDto = {
          
          firstRow: {
            firstTitle: categories[OBJECT_TYPE]?.categoryName || '',
            firstValue: categories[OBJECT_TYPE]?.wordName || '',
            secondTitle: categories[OBJECT_PART]?.categoryName || '',
            secondValue: categories[OBJECT_PART]?.wordName || '',
            thirdTitle: categories[TIPUS]?.categoryName || '',
            thirdValue: categories[TIPUS]?.wordName || '',
            isEmpty: !(categories[OBJECT_TYPE]?.wordName.hebrew || categories[OBJECT_TYPE]?.wordName.english || categories[OBJECT_PART]?.wordName.hebrew || categories[OBJECT_PART]?.wordName.english || categories[TIPUS]?.wordName.hebrew || categories[TIPUS]?.wordName.english),
          },
          secondRow: {
            firstTitle: categories[SHALIT]?.categoryName || '',
            firstValue: categories[SHALIT]?.wordName || '',
            secondTitle: categories[TAT_SHALIT]?.categoryName || '',
            secondValue: categories[TAT_SHALIT]?.wordName || '',
            thirdTitle: new MultiLangStrDto('שנים','Years'),
            thirdValue: new MultiLangStrDto (objectDetails.objectYears?.join(',') || '',objectDetails.objectYears?.join(',') || ''),
            isEmpty: !(categories[SHALIT]?.wordName.hebrew ||categories[SHALIT]?.wordName.english || categories[TAT_SHALIT]?.wordName.hebrew || categories[TAT_SHALIT]?.wordName.english || objectDetails.objectYears?.length),
          },
          thirdRow: {
            firstTitle: categories[MITBAAH]?.categoryName || '',
            firstValue: categories[MITBAAH]?.wordName || '',
            secondTitle: categories[ARICH]?.categoryName || '',
            secondValue: categories[ARICH]?.wordName || '',
            thirdTitle: categories[TVIAT_RECHEV]?.categoryName || '',
            thirdValue: categories[TVIAT_RECHEV]?.wordName || '',
            isEmpty: !(categories[MITBAAH]?.wordName.hebrew || categories[MITBAAH]?.wordName.english || categories[ARICH]?.wordName.hebrew || categories[ARICH]?.wordName.english || categories[TVIAT_RECHEV]?.wordName.hebrew || categories[TVIAT_RECHEV]?.wordName.english),
          },
          fourthRow: {
            firstTitle: categories[MANUSCRIPT_TYPE]?.categoryName || '',
            firstValue: categories[MANUSCRIPT_TYPE]?.wordName || '',
            secondTitle: categories[CHIBUR_TYPE]?.categoryName || '',  
            secondValue: categories[CHIBUR_TYPE]?.wordName || '',
            thirdTitle: categories[SUGA]?.categoryName || '',
            thirdValue: categories[SUGA]?.wordName || '',
            isEmpty: !(categories[MANUSCRIPT_TYPE]?.wordName.hebrew || categories[MANUSCRIPT_TYPE]?.wordName.english || categories[CHIBUR_TYPE]?.wordName.hebrew || categories[CHIBUR_TYPE]?.wordName.english || categories[SUGA]?.wordName.hebrew || categories[SUGA]?.wordName.english),
          },  
          fifthRow: {
            firstTitle: categories[CHIBUR]?.categoryName || '',
            firstValue: categories[CHIBUR]?.wordName || '',
            secondTitle: categories[TAT_CHIBUR]?.categoryName || '',
            secondValue: categories[TAT_CHIBUR]?.wordName || '',
            thirdTitle: categories[KITZUR]?.categoryName || '',
            thirdValue: categories[KITZUR]?.wordName || '',
            isEmpty: !(categories[CHIBUR]?.wordName.hebrew || categories[CHIBUR]?.wordName.english || categories[TAT_CHIBUR]?.wordName.hebrew || categories[TAT_CHIBUR]?.wordName.english || categories[KITZUR]?.wordName.hebrew || categories[KITZUR]?.wordName.english),
          },     
          sixthRow: {
            firstTitle: categories[COPY]?.categoryName || '',
            firstValue: categories[COPY]?.wordName || '',
            secondTitle: categories[LANGUAGE]?.categoryName || '',
            secondValue: categories[LANGUAGE]?.wordName || '',
            thirdTitle: categories[WRITING]?.categoryName || '',
            thirdValue: categories[WRITING]?.wordName || '',
            isEmpty: !(categories[COPY]?.wordName.hebrew || categories[COPY]?.wordName.english || categories[LANGUAGE]?.wordName.hebrew || categories[LANGUAGE]?.wordName.english || categories[WRITING]?.wordName.hebrew || categories[WRITING]?.wordName.english),
          },
          seventhRow: {
            firstTitle: categories[PERIOD_ISRAEL]?.categoryName || '',
            firstValue: categories[PERIOD_ISRAEL]?.wordName || '',
            secondTitle: new MultiLangStrDto('מוצא','Provenance'),
            secondValue: new MultiLangStrDto(objectDetails.objectDiscoveryMethods.join(', ') || '',objectDetails.objectDiscoveryMethods.join(', ') || ''),
            thirdTitle:new MultiLangStrDto( 'אתר','Site'),
            thirdValue: siteValue,
            isEmpty: !(categories[PERIOD_ISRAEL]?.wordName.hebrew || categories[PERIOD_ISRAEL]?.wordName.english || objectDetails.objectDiscoveryMethods?.length),
          },
          eighthRow: {
            firstTitle: categories[MATERIAL]?.categoryName || '',
            firstValue: categories[MATERIAL]?.wordName || '',
            secondTitle: categories[TECHNIQUE]?.categoryName || '',
            secondValue: categories[TECHNIQUE]?.wordName || '',
            thirdTitle: new MultiLangStrDto('ממדים','Dimensions'),
            thirdValue:new MultiLangStrDto(objectDetails.objectDimensions?.map((d) => `${d.dimensionName.hebrew}: ${d.dimensionValue} ${d.dimensionUnits}`).join(', ') || '',
            objectDetails.objectDimensions?.map((d) => `${d.dimensionName.english}: ${d.dimensionValue} ${d.dimensionUnits}`).join(', ') || ''),
            isEmpty: !(categories[MATERIAL]?.wordName.hebrew || categories[MATERIAL]?.wordName.english || categories[TECHNIQUE]?.wordName.hebrew || categories[TECHNIQUE]?.wordName.english || objectDetails.objectDimensions?.length),
          },
          ninthRow: {
            firstTitle: categories[PERIOD_OVERSEAS]?.categoryName || '',
            firstValue: categories[PERIOD_OVERSEAS]?.wordName || '',
            secondTitle: categories[KEYWORDS]?.categoryName || '',
            secondValue: categories[KEYWORDS]?.wordName || '',
            thirdTitle: new MultiLangStrDto('',''),
            thirdValue: new MultiLangStrDto('',''),
            isEmpty: !(categories[PERIOD_OVERSEAS]?.wordName.hebrew || categories[PERIOD_OVERSEAS]?.wordName.english || categories[KEYWORDS]?.wordName.hebrew || categories[KEYWORDS]?.wordName.english),
          },
          tenthRow: {
            expeditionTitle:new MultiLangStrDto('משלחת','Expedition'),
            expeditionValue: objectDetails.objectExpedition?.expeditionName|| '',
            licencesTitle: new MultiLangStrDto('רישיונות','Excavation Licenses/Permits'),
            licencesValue: objectDetails.objectLicenses?.licenses.map((l) => 
              new MultiLangStrDto(l.shortName, l.shortName)),           
            isEmpty: !(objectDetails.objectExpedition?.expeditionName.hebrew || objectDetails.objectExpedition?.expeditionName.english || objectDetails.objectLicenses?.licenses.length),
          },     
          eleventhRow: {
            firstTitle: new MultiLangStrDto('לוקוס ','Locus') ,
            firstValue: new MultiLangStrDto(objectDetails.locusId || '',objectDetails.locusId || ''),
            secondTitle:new MultiLangStrDto('שכבה','Layer'),  
            secondValue: new MultiLangStrDto(objectDetails.objectLayer || '',objectDetails.objectLayer || '') ,
            thirdTitle: new MultiLangStrDto('סל','Basket'),
            thirdValue: new MultiLangStrDto(objectDetails.basketId,objectDetails.basketId),
            isEmpty: !(objectDetails.locusId || objectDetails.objectLayer || objectDetails.basketId)
          },
          twelvthRow: {
            firstTitle: new MultiLangStrDto('מספר פנימי','IAA Number'),
            firstValue: new MultiLangStrDto(objectDetails.objectId || '',objectDetails.objectId || ''),
            secondTitle: new MultiLangStrDto ('מיקום פריט','Item Location'),
            secondValue: new MultiLangStrDto(objectDetails.objectStorage || '',objectDetails.objectStorage || ''),
            thirdTitle:new MultiLangStrDto('לוח','Plate'),
            thirdValue: new MultiLangStrDto('',''),
            isEmpty: !(objectDetails.objectId || objectDetails.objectStorage),
          }
        };        
    return rows;
  }
}
